var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutiveDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#D1B277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2117)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2117)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122.429L34 86.2143H43.8378L60 107.571V122.429Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50L34 86.2143H43.8378L60 64.8571V50Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122.429L86 86.2143H76.1622L60 107.571V122.429Z",
    fill: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50L86 86.2143H76.1622L60 64.8571V50Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 86.213L60.0137 64.8559L76.1759 86.213L60.0137 107.57L43.8516 86.213Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2117",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#CFB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED4A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2117",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484157"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveDiamond);
export default __webpack_public_path__ + "static/media/executiveDiamond.21cbb04e12852b1623631c0817fe2791.svg";
export { ForwardRef as ReactComponent };